import {isNonEmptyArray, isNonEmptyObject} from "@cayuse/shared-react.utils.type-checks";
import {SELECT_ALL_KEY} from "globals/constants";
import {assembleFormSectionsAndElements} from "utils";
import {api} from "services";


export const getTotalSubawards = ({ searchTerms }) => {
	return findSubawards({
		pageLimit: 1,
		pageOffset: 0,
		searchTerms,
		fieldKeys: [ "subawardId" ]
	})
		.then(({ totalItems }) => {
			return totalItems;
		});
};

export const fetchSubaward = async (subawardId) => {
	const subaward = await api.subaward.get(subawardId);

	const { formElements, formSections } = assembleFormSectionsAndElements(subaward.formElements);

	return { ...subaward, formElements, formSections };
};

export const findSubawards = async ({
	awardId,
	pageLimit: incomingPageLimit,
	pageOffset,
	searchTerms,
	fieldKeys
}) => {
	const pageLimit = incomingPageLimit === SELECT_ALL_KEY
		? await getTotalSubawards({ searchTerms })
		: incomingPageLimit;

	if (pageLimit === 0) {
		return Promise.resolve({ items: [], totalItems: 0 });
	}

	const data = await api.subaward.getList(awardId, {
		page: pageOffset,
		size: pageLimit,
		search: searchTerms,
		fields: fieldKeys,
	});

	const subawardFeedItems = data?.content;
	const hasSubawardFeedItems = isNonEmptyArray(subawardFeedItems);

	const mappedColumnValues = subawardFeedItems?.map(subawardFeedItem => {
		const hasColumnValues = isNonEmptyObject(subawardFeedItem.columnValues);

		if (!hasColumnValues) {
			return {};
		}

		return {
			...subawardFeedItem.columnValues,
			subRows: isNonEmptyObject(subawardFeedItem.modifications)
				? subawardFeedItem.modifications.map((subFeed) => ({
					...subFeed.columnValues,
					adminTeamMemberData: subFeed.adminTeamMembers,
					modificationStatus: subFeed.modificationStatus,
				}))
				: [],
			adminTeamMemberData: subawardFeedItem.adminTeamMembers,
			modificationStatus: subawardFeedItem.modificationStatus,
		};
	});

	return {
		items: hasSubawardFeedItems ? mappedColumnValues : [],
		totalItems: data?.totalElements,
	};
};
